/* Bandeau « Livraison offerte » — NOCCA
   ------------------------------------------------------------------
   Une seule chose à faire : quand le client vient de franchir le seuil,
   rejouer la barre jusqu'à 100 % avant d'afficher « Livraison offerte ».

   Pourquoi un custom element plutôt qu'un script inline : quand le
   panier change, le thème re-rend le tiroir et remplace son HTML. Les
   <script> insérés de cette façon ne sont jamais exécutés, alors qu'un
   custom element est réveillé automatiquement par le navigateur à
   chaque insertion. C'est le seul moyen fiable de savoir qu'on vient
   d'afficher le bandeau.

   Le nombre de paires du panier précédent est gardé dans le
   sessionStorage : c'est lui qui dit si le seuil vient d'être franchi
   ou s'il l'était déjà. Un rechargement de page ne rejoue donc pas
   l'animation, et un nouvel onglet repart de zéro.

   Sans JavaScript, ou si le stockage est refusé, le bandeau s'affiche
   directement dans son état final. Rien ne dépend de ce fichier pour
   être correct, seulement pour être animé. */

(function () {
  'use strict';

  var CLE = 'nocca-livraison-paires';

  /* Durées, en millisecondes. Doivent rester cohérentes avec les
     transitions déclarées dans nocca-livraison-offerte.css. */
  var REMPLISSAGE = 520;
  var SORTIE = 200;

  function lirePairesPrecedentes() {
    try {
      var v = window.sessionStorage.getItem(CLE);
      return v === null ? null : parseInt(v, 10);
    } catch (e) {
      return null;
    }
  }

  function retenirPaires(n) {
    try {
      window.sessionStorage.setItem(CLE, String(n));
    } catch (e) {
      /* Navigation privée ou stockage bloqué : on s'en passe. */
    }
  }

  function mouvementReduit() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  var NoccaLivraisonOfferte = (function () {
    function NoccaLivraisonOfferte() {
      return Reflect.construct(HTMLElement, [], NoccaLivraisonOfferte);
    }

    NoccaLivraisonOfferte.prototype = Object.create(HTMLElement.prototype);
    NoccaLivraisonOfferte.prototype.constructor = NoccaLivraisonOfferte;
    Object.setPrototypeOf(NoccaLivraisonOfferte, HTMLElement);

    NoccaLivraisonOfferte.prototype.connectedCallback = function () {
      var paires = parseInt(this.dataset.paires, 10) || 0;
      var atteint = this.dataset.atteint === 'true';
      var precedentes = lirePairesPrecedentes();

      retenirPaires(paires);

      /* On anime seulement au franchissement : le seuil est atteint
         maintenant, il ne l'était pas juste avant. */
      var vientDeFranchir =
        atteint && precedentes !== null && precedentes < paires && precedentes < (parseInt(this.dataset.pairesPack, 10) || 2);

      if (!vientDeFranchir || mouvementReduit()) return;

      var gabarit = this.querySelector('[data-nocca-livraison-progression]');
      if (!gabarit || !gabarit.content) return;

      this.jouerTransition(gabarit, precedentes);
    };

    NoccaLivraisonOfferte.prototype.jouerTransition = function (gabarit, precedentes) {
      var element = this;
      var pairesPack = parseInt(this.dataset.pairesPack, 10) || 2;
      var depart = Math.round((precedentes * 100) / pairesPack);

      /* On met de côté l'état final pour le restaurer ensuite. */
      var contenuFinal = this.innerHTML;

      /* On fige la hauteur du moment pour éviter un saut, puis on
         installe la couche « progression » à la place du contenu. */
      var hauteurFinale = this.offsetHeight;

      this.classList.add('nocca-livraison--en-transition');
      this.classList.remove('nocca-livraison--offerte');
      this.classList.add('nocca-livraison--progression');
      this.innerHTML = '';
      this.appendChild(gabarit.content.cloneNode(true));

      var barre = this.querySelector('.nocca-livraison__barre-remplissage');
      if (barre) barre.style.width = depart + '%';

      var hauteurProgression = this.offsetHeight;
      this.style.height = hauteurProgression + 'px';

      /* Deux images d'attente : la largeur de départ doit être peinte
         avant qu'on demande la largeur d'arrivée, sinon le navigateur
         fusionne les deux et la barre saute sans animer. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (barre) barre.style.width = '100%';
        });
      });

      window.setTimeout(function () {
        element.classList.add('nocca-livraison--sortie');

        window.setTimeout(function () {
          element.classList.remove('nocca-livraison--progression');
          element.classList.remove('nocca-livraison--sortie');
          element.classList.add('nocca-livraison--offerte');
          element.innerHTML = contenuFinal;
          element.style.height = hauteurFinale + 'px';
          element.classList.add('nocca-livraison--entree');

          window.setTimeout(function () {
            element.style.height = '';
            element.classList.remove('nocca-livraison--en-transition');
            element.classList.remove('nocca-livraison--entree');
          }, 420);
        }, SORTIE);
      }, REMPLISSAGE);
    };

    return NoccaLivraisonOfferte;
  })();

  if (!window.customElements.get('nocca-livraison-offerte')) {
    window.customElements.define('nocca-livraison-offerte', NoccaLivraisonOfferte);
  }
})();
